import React, { useState, useEffect, memo } from 'react'
import PropTypes from 'prop-types'
import { Anchor, Button, Icon } from 'antd'
import classnames from 'classnames'
import { useSelector } from 'react-redux'
import { UseIntentOrder } from '../intent-modal/order'
import styles from './index.scss'
import { getCarParams } from './service'

const { Link } = Anchor

const CarConfiguration = ({ basicInfo, carId }) => {
  const isParallelImportCar = basicInfo?.title && basicInfo?.title?.indexOf('平行进口车') > -1 // 根据title判断是否为平行进口车
  const [vehicleConfig, setVehicleConfig] = useState()
  const { phone } = useSelector(store => store.user)
  const { city } = useSelector(store => store)
  const { fr, ino } = city
  const [triggScorll, setTriggScorll] = useState(false)
  const [linkToBottom, setLinkToBottom] = useState(false)
  const [targetOffset] = useState(100)
  const [sechAllOpen, setSechAllOpen] = useState(isParallelImportCar)
  const [defaultTab, setDefaultTab] = useState(true)
  // 是顶部nav高度
  const [headerNavHeight] = useState(60)
  const bindHandleScroll = () => {
    if (!sechAllOpen) { return }
    const father = document.querySelector('#linkContainer')
    const son = document.querySelector('.anchor')
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    const fatherTop = father.offsetTop
    const fatherHeight = father.offsetHeight
    const sonHeight = son.offsetHeight

    // 未滚动至顶部指定高亮项（anchor默认当滚动到顶部后开始适配高亮项）
    const btnOffsetHeight = document.querySelector('.adviceCar').offsetHeight
    if (fatherTop + btnOffsetHeight > scrollTop + headerNavHeight) {
      setDefaultTab(true)
    } else {
      setDefaultTab(false)
    }

    if (fatherHeight + fatherTop - sonHeight - scrollTop <= headerNavHeight) {
      setTriggScorll(false)
      setLinkToBottom(true)
    }
    if (fatherHeight + fatherTop - sonHeight - scrollTop > headerNavHeight) {
      setTriggScorll(true)
      setLinkToBottom(false)
    }
  }

  const getVehicleConfigFuc = async () => {
    try {
      const result = await getCarParams({ car_id: carId })
      if (isParallelImportCar) {
        setVehicleConfig(result?.data?.vehicleConfig?.filter(e => e.name === '基本参数'))
      } else {
        setVehicleConfig(result?.data?.vehicleConfig)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const anchorClick = (e) => {
    e.preventDefault()
  }

  const searchAll = () => {
    setSechAllOpen(true)
  }

  const wrapDiv = (obj, arr) => {
    const newArr = []
    const recurs = () => {
      if (arr.length === 0) {
        return newArr
      }
      newArr.push(
        <div className="params_table_con" key={newArr.length}>
          {arr.splice(0, 3).map((item, idx) => (
            <div key={idx} className="table_td">
              <li className={classnames('left', { blur: obj[item] === '无' || obj[item] === '' })}>{item}</li>
              <li title={obj[item]} className={classnames('right', { blur: obj[item] === '无' || obj[item] === '' })}>{obj[item] ? obj[item] : '无'}</li>
            </div>
          ))}
        </div>
      )
      return recurs()
    }
    return recurs()
  }

  useEffect(() => {
    getVehicleConfigFuc()
    window.addEventListener('scroll', bindHandleScroll)
    return () => {
      window.removeEventListener('scroll', bindHandleScroll)
    }
  }, [sechAllOpen])

  // 咨询车况
  const toConsult = () => {
    global.$rbl.push({
      event: 'car-detail_configuration-consult_click',
      content: {
        param: '咨询-PC-详情页-12'
      }
    })
    const submitParams = {
      mobile_number: phone || '',
      phone_source: `${fr}${ino ? '_异地' : ''}`,
      sub_product: '咨询',
      submit_sources: '咨询-PC-详情页-12'
    }
    const otherParams = { ino, basicInfo }
    new UseIntentOrder({ intentType: 'consult', submitParams, otherParams }).open()
  }

  // Anchor 组件： getCurrentAnchor 自定义高亮项，值 null 自适应，可函数返回指定项，返回null时 不能自适应
  return (
    <>
      <div className={styles.config} data-exposure="car-detail_configuration_display">
        <div id="linkContainer" className={classnames('paramBox', { auto: sechAllOpen })}>
          <div className={classnames('paramLink', { absloute: linkToBottom })}>
            <Anchor
              bounds={0}
              className={classnames('anchor')}
              affix={triggScorll}
              offsetTop={headerNavHeight}
              targetOffset={targetOffset}
              onClick={(e, link) => { anchorClick(e, link) }}
              getCurrentAnchor={defaultTab ? () => '#table0' : null}
            >
              <div className="title">配置参数</div>
              {
              vehicleConfig && vehicleConfig.map((item, index) => (
                <Link key={item.name + index} href={`#table${index}`} id={`table${index}`} title={item.name} />
              ))
            }
            </Anchor>
          </div>
          <div className="paramTable">
            <div className="adviceCar">
              {!basicInfo?.sold
              && (
                <Button className="adviceBtn" ghost onClick={toConsult}>
                  <Icon type="message" theme="twoTone" twoToneColor="#fd521d" /> 咨询车况
                </Button>
              )
            }
            </div>
            {
            vehicleConfig && vehicleConfig.map((item, index) => (
              <div
                id={`table${index}`}
                key={index}
                className="params_table"
                data-exposure={JSON.stringify({
                  event: 'car-detail_configuration_display',
                  content: {
                    expand: { tag_value: item.name }
                  }
                })}
              >
                <div className="title">
                  <span>{item.name}</span>
                </div>
                {
                  wrapDiv(item.config, Object.keys(item.config))
                }
              </div>
            ))
       }
          </div>
          <div className={classnames('multLayers', { invalidBtn: sechAllOpen })} onClick={() => { searchAll() }} />
          <div className={classnames('seachAll', { invalidBtn: sechAllOpen })}>
            <Button className={classnames('seachAllBtn')} onClick={() => { global.$rbl.push('car-detail_configuration-configurationmore_click'); searchAll() }}>
              查看所有参数 <Icon type="double-left" className="seachAllIcon" />
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}

export default memo(CarConfiguration)

CarConfiguration.propTypes = {
  basicInfo: PropTypes.object,
  carId: PropTypes.string
}

CarConfiguration.defaultProps = {
  basicInfo: {},
  carId: ''
}
